// Navigation + Footer + language switch
export default {
  "nav.home": { es: "Inicio", ca: "Inici" },
  "nav.method": { es: "Método TAO", ca: "Mètode TAO" },
  "nav.story": { es: "Mi Historia", ca: "La Meva Història" },
  "nav.oncology": { es: "Oncología", ca: "Oncologia" },
  "nav.fibromyalgia": { es: "Fibromialgia", ca: "Fibromiàlgia" },
  "nav.online": { es: "Online", ca: "Online" },
  "nav.testimonials": { es: "Testimonios", ca: "Testimonis" },
  "nav.press": { es: "Prensa", ca: "Premsa" },
  "nav.blog": { es: "Blog", ca: "Blog" },
  "nav.contact": { es: "Contacto", ca: "Contacte" },
  "nav.freeSession": { es: "Sesión gratuita · 15 min", ca: "Sessió gratuïta · 15 min" },
  "nav.bookSession": { es: "Reserva tu sesión gratuita", ca: "Reserva la teva sessió gratuïta" },

  "footer.tagline": { es: "Acompañamiento cuerpo-mente. Yoga oncológico, fibromialgia y fatiga crónica.", ca: "Acompanyament cos-ment. Ioga oncològic, fibromiàlgia i fatiga crònica." },
  "footer.navigation": { es: "Navegación", ca: "Navegació" },
  "footer.faq": { es: "Preguntas frecuentes", ca: "Preguntes freqüents" },
  "footer.professionals": { es: "Para profesionales sanitarios", ca: "Per a professionals sanitaris" },
  "footer.associations": { es: "Para asociaciones y hospitales", ca: "Per a associacions i hospitals" },
  "footer.contact": { es: "Contacto", ca: "Contacte" },
  "footer.cta": { es: "¿Empezamos a hablar?", ca: "Comencem a parlar?" },
  "footer.ctaButton": { es: "Reserva sesión gratuita", ca: "Reserva sessió gratuïta" },
  "footer.rights": { es: "Todos los derechos reservados", ca: "Tots els drets reservats" },
  "footer.philosophyTag": { es: "No acompañamos enfermedades. Acompañamos personas.", ca: "No acompanyem malalties. Acompanyem persones." },
  "brand.first": { es: "Método", ca: "Mètode" },
  "lang.switch": { es: "Idioma", ca: "Idioma" },
};
